import { registerCommand } from '../registry';
import type { ScopedSearchCommandDef } from '../types';

/**
 * `/parcel <name | parcel id>` — restrict search to GIS parcel
 * sublayers only. Unlike `/transcript` and `/chat` (which run a
 * single in-memory executor), parcel hits the live ArcGIS feature
 * services, so the host runs `buildGisLayerSearchUnits` directly
 * with `primary='parcel'` to:
 *   - skip every non-parcel sublayer (hydrants, traffic, etc.)
 *   - search only parcel-shaped fields (`apn`, `pin`, `pid`, owner,
 *     parcel name) instead of the full generic field set
 * Bypasses the AI classifier and the broader orchestrator entirely;
 * the regular dropdown is left untouched while the palette renders
 * the scoped parcel hits.
 */
const parcelCommand: ScopedSearchCommandDef = {
  id: 'parcel',
  kind: 'scopedSearch',
  scopedFilter: 'parcel',
  title: 'Search parcels',
  description: 'Search GIS parcel layers by owner name or parcel ID.',
  usage: '<name or parcel id>',
};

registerCommand(parcelCommand);

export default parcelCommand;
